/* eslint-disable no-shadow */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { memo, useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  ModalContent,
  ModalHeader,
  Button,
  Text,
  Space,
  Conditional,
  InputField,
  Popup,
  UploadFile,
} from '@cashfree-intl/coherent';

import FormikComponent from 'components/Formik';
import CustomIcon from 'components/CustomIcons';
import Loader from 'components/Loader';
import { previewFile, titleCase } from 'utils/common';
import { useLocalStorage } from 'hooks/useLocalStorage';

import {
  StyledDocCategoryDivider,
  StyledStatusText,
  StyledTextDivider,
} from '../../../styled';
import {
  ACTION_REQUIRED,
  AUTO_VERIFIED_DOCS,
  CIN,
  GSTIN,
  INPUT_PLACEHOLDER_MAPPING,
  IN_KYC_REVIEW,
  PAN,
  SAVE_AND_EXIT_BTN_INFO_TEXT,
  STATUS_COLOR_MAPPING,
  STATUS_TEXT_DISPLAY_MAPPING,
  VALUE,
  VERIFIED,
} from '../../../constants';

import kycFormV2ValidationSchema from './Validations/KycFormV2Validation';
import {
  findDocForEveryCategory,
  prepareDocumentsObj,
  sortVendorKycDocuments,
} from './helpers';

export function KycFormV2({
  open,
  isEditMode,
  editModalLoading,
  step,
  setStep,
  vendorDocs,
  submitVendorDocuments,
  verifyPan,
  verifyCin,
  verifyGst,
  saveAndExitKycForm,
  userInfo: { userName, name },
  setVendorCreated,
  downloadDoc,
  merchantVendorId,
  vendorOnboardingDetails,
  vendorFormData,
  setVendorFormData,
}) {
  setVendorCreated(true);

  const [loading, setLoading] = useState('');
  const [gstinRemarks, setGstinRemarks] = useState('');
  const [tempValues, setTempValues] = useLocalStorage('vendorKycFormData');

  const tempValuesRef = useRef({});
  const vendorFormValuesRef = useRef({ ...vendorFormData });

  useEffect(() => {
    tempValuesRef.current = { ...tempValues };
    vendorFormValuesRef.current = { ...vendorFormData };
  }, [tempValues, vendorFormData]);

  const updateValuesToLS = () => {
    setTempValues(tempValuesRef.current);
    setVendorFormData(vendorFormValuesRef.current);
  };
  let docTypeDocNameMapping = {};
  const optionalDocs = { input: [], doc: [] };
  let docValues = {};
  let docStatus = {};
  let inputDocs = {};

  let docsRejectionReason = {};
  const docCategoryList = [];
  let documentList = [];
  const docInputTypeMapping = {};

  const submitForm = (values, actions) => {
    const payload = { inputs: {}, docs: {} };
    Object.keys(values).forEach(value => {
      if (!AUTO_VERIFIED_DOCS.includes(value)) {
        if (
          typeof values[value] === 'string' &&
          values[value].length > 0 &&
          (docInputTypeMapping[value] === 'input' ||
            optionalDocs?.input.includes(value))
        ) {
          payload.inputs[value] = values[value];
        } else if (typeof values[value] !== 'string') {
          payload.docs[value] = values[value];
        }
      }
    });
    submitVendorDocuments(payload, docTypeDocNameMapping, actions);
    localStorage.removeItem('vendorKycFormData');
    localStorage.removeItem('vendorFormData');
  };

  const onClickCrossHandler = () => {
    updateValuesToLS();
    setStep(0);
  };

  const prepareDocCategoryList = () => {
    const { documents = [] } = vendorDocs;
    documents.forEach(docs => {
      const { docRequirements } = docs;
      const docRequirementList = docRequirements
        .filter(doc => doc.isRecommended)
        .map(doc => doc.docName);
      if (docRequirementList.length) {
        docCategoryList.push(docRequirementList);
      }
    });
  };

  if (vendorDocs?.documents?.length > 0) {
    prepareDocCategoryList();
    const documentsObj = prepareDocumentsObj(vendorDocs);
    documentList = documentsObj.docList;
    docValues = documentsObj.documentValues;
    docStatus = documentsObj.documentStatus;
    inputDocs = documentsObj.inputDocuments;
    docsRejectionReason = documentsObj.documentRejectionReason;
    docTypeDocNameMapping = documentsObj.documentTypeDocNameMapping;
  }

  const formDocValues = { ...docValues };

  const initialValues = { ...tempValues };

  return (
    <Modal
      open={open}
      className="common-modal-wrapper add-vendorV2-wrapper"
      $maxWidth="520"
    >
      <ModalHeader>
        <div>
          <div className="heading">
            {`${isEditMode ? 'Edit' : 'Add '} Vendor`}
          </div>
        </div>
        <div
          className="close-modal"
          data-event-name="Form_KYCForm_Icon_Close"
          data-ignore-inner-text="true"
          onClick={onClickCrossHandler}
        >
          <CustomIcon componentName="CLOSE" />
        </div>
      </ModalHeader>
      <ModalContent>
        <div className="modal-content loading-modal">
          <Loader active={editModalLoading} isModal paragraph={2} />
          {!editModalLoading && vendorDocs?.documents?.length > 0 && (
            <FormikComponent
              initialValues={initialValues}
              validationSchema={kycFormV2ValidationSchema}
              onSubmit={submitForm}
            >
              {({
                values = {},
                handleFieldBlur,
                handleFieldChange: onHandleFieldChange,
                handleSubmit,
                errors,
                touched,
                setFieldValue,
                setFieldTouched,
                setStatus,
                setErrors,
                status = { fieldValidationResponse: {} },
                validateForm,
                ...formikProps
              }) => {
                const handleFieldChange = (e, data) => {
                  onHandleFieldChange(e, data);
                  tempValuesRef.current = {
                    ...values,
                    ...tempValuesRef.current,
                    [data.name]: data?.value,
                  };
                };
                const disableField =
                  (!formikProps.isValidating && formikProps.isSubmitting) ||
                  !!loading;

                const docForEveryCateogorySubmitted = findDocForEveryCategory(
                  docTypeDocNameMapping,
                  inputDocs,
                  values,
                  isEditMode,
                );

                const showPreview = doc => {
                  if (values[doc]) {
                    if (values[doc].type) {
                      previewFile(URL.createObjectURL(values[doc]));
                    } else {
                      downloadDoc({
                        data: { docType: doc, merchantVendorId },
                        cb: response => {
                          if (response.downloadUrl) {
                            previewFile(response.downloadUrl);
                          }
                        },
                      });
                    }
                  }
                };

                const handleSaveAndExitClick = () => {
                  const payload = { inputs: {}, docs: {} };
                  Object.keys(values).forEach(value => {
                    if (!AUTO_VERIFIED_DOCS.includes(value)) {
                      if (
                        typeof values[value] === 'string' &&
                        values[value].length > 0 &&
                        (docInputTypeMapping[value] === 'input' ||
                          optionalDocs?.input.includes(value))
                      ) {
                        payload.inputs[value] = values[value];
                      } else if (typeof values[value] !== 'string') {
                        payload.docs[value] = values[value];
                      }
                    }
                  });
                  saveAndExitKycForm(payload, docTypeDocNameMapping);
                  localStorage.removeItem('vendorKycFormData');
                  localStorage.removeItem('vendorFormData');
                };

                if (Object.keys(formDocValues).length > 0) {
                  Object.keys(formDocValues).forEach(doc => {
                    if (!values[doc]) {
                      if (formDocValues[doc] !== null) {
                        setFieldValue(doc, formDocValues[doc]);
                      } else {
                        setFieldValue(doc, '');
                      }
                    }
                    delete formDocValues[doc];
                  });
                }

                if (Object.keys(docsRejectionReason).length > 0 && isEditMode) {
                  setStatus({ ...docsRejectionReason });
                  docsRejectionReason = {};
                }

                const handleFileChange = (fileObj, docName) => {
                  const { file = {} } = fileObj;
                  setFieldValue(docName, file);
                  // eslint-disable-next-line no-param-reassign
                  delete status[docName];
                };
                // eslint-disable-next-line consistent-return
                const displayStatus = inputField => {
                  let docDisplayStatus = docStatus;
                  if (values[inputField] !== docValues[inputField]) {
                    docDisplayStatus = '';
                  }
                  if (
                    status.fieldValidationResponse?.[inputField] ||
                    docDisplayStatus?.[inputField]
                  ) {
                    return (
                      STATUS_TEXT_DISPLAY_MAPPING[
                        status.fieldValidationResponse?.[inputField] ||
                          docDisplayStatus?.[inputField]
                      ] ||
                      titleCase(
                        status.fieldValidationResponse?.[inputField] ||
                          docDisplayStatus?.[inputField],
                      )
                    );
                  }
                };
                const displayTextStatus = inputField => {
                  let docDisplayStatus = docStatus;
                  if (values[inputField] !== docValues[inputField]) {
                    docDisplayStatus = '';
                  }
                  return (
                    status.fieldValidationResponse?.[inputField] ||
                    docDisplayStatus?.[inputField]
                  );
                };
                const renderInputLabel = inputField => (
                  <Space
                    justifyContent="space-between"
                    alignItems="baseline"
                    className="mb-1"
                  >
                    <Space gap={1} alignItems="center">
                      <Text>{inputField}</Text>
                      <Conditional if={optionalDocs.input.includes(inputField)}>
                        <div className="optional-field-label">Optional</div>
                      </Conditional>
                    </Space>
                    <Conditional
                      if={
                        (isEditMode && docStatus[inputField]) ||
                        (status.fieldValidationResponse?.[inputField] &&
                          status.fieldValidationResponse?.[inputField] !== '')
                      }
                    >
                      <StyledStatusText
                        color={
                          STATUS_COLOR_MAPPING[
                            status?.fieldValidationResponse?.[inputField] ||
                              docStatus?.[inputField]
                          ] || 'bodyLight'
                        }
                        status={displayTextStatus(inputField)}
                      >
                        {displayStatus(inputField)}
                      </StyledStatusText>
                    </Conditional>
                  </Space>
                );

                function findGSTINDocument(documents) {
                  return documents
                    .flatMap(doc => doc.docRequirements) // Flatten the array of requirements
                    .find(req => req.docName === 'GSTIN'); // Find the requirement with the name "GSTIN"
                }

                const extractGSTIN = (response = {}) => {
                  // populate the GSTIN from the api response
                  // and show remarks which we got in the api response
                  // If GSTIN is not available then show static message below GSTIN input
                  const { documents = [] } = response;
                  const gstinDocument = findGSTINDocument(documents);
                  setFieldValue('GSTIN', gstinDocument?.docValue);
                  setGstinRemarks(gstinDocument?.remarks);
                  // gst is present
                  if (gstinDocument?.docStatus === VERIFIED) {
                    // look at the condition - Prem
                  } else {
                    setGstinRemarks(
                      gstinDocument?.docValue
                        ? ''
                        : 'Unable to find linked GST using PAN',
                    );
                  }
                };

                const validateInputField = (e, data, inputField) => {
                  const loadingFn = () => {
                    setLoading(inputField);
                  };

                  const errorCb = () => {
                    setLoading('');
                  };

                  switch (inputField) {
                    case PAN:
                      if (
                        e.target.value &&
                        e.target.value.length === 10 &&
                        new RegExp(/[A-Z]{5}[0-9]{4}[A-Z]{1}/).test(
                          e.target.value,
                        )
                      ) {
                        verifyPan({
                          payload: {
                            pan: e.target.value,
                            parentType: 'MERCHANT',
                            userName,
                            name: vendorOnboardingDetails?.name || name,
                          },
                          extractGSTIN,
                          loadingFn,
                          errorCb,
                          cb: response => {
                            setLoading('');
                            const {
                              isNameMatchSuccessful,
                              isValid,
                              message,
                            } = response;

                            const { fieldValidationResponse } = status;
                            const modifiedStatus = {
                              ...fieldValidationResponse,
                            };

                            let remarks = '';
                            if (isValid && isNameMatchSuccessful) {
                              modifiedStatus[inputField] = VERIFIED;
                              docStatus[inputField] = VERIFIED;
                            } else {
                              modifiedStatus[inputField] = ACTION_REQUIRED;
                              docStatus[inputField] = ACTION_REQUIRED;
                              remarks = message;
                            }
                            setTimeout(
                              () =>
                                setStatus({
                                  ...status,
                                  [inputField]: remarks,
                                  fieldValidationResponse: {
                                    ...modifiedStatus,
                                  },
                                }),
                              0,
                            );
                          },
                        });
                      }
                      break;
                    case GSTIN:
                      if (
                        e.target.value &&
                        e.target.value.length === 15 &&
                        new RegExp(/^[0-9]{2}[A-Z|a-z|0-9]{13}$/).test(
                          e.target.value,
                        )
                      ) {
                        verifyGst({
                          payload: {
                            parentType: 'MERCHANT',
                            userName,
                            name: vendorOnboardingDetails?.name || name,
                            GSTIN: e.target.value,
                          },
                          loadingFn,
                          errorCb,
                          cb: response => {
                            setLoading('');
                            const { isValid, message } = response;

                            const { fieldValidationResponse } = status;
                            const modifiedStatus = {
                              ...fieldValidationResponse,
                            };

                            let remarks = '';

                            if (isValid) {
                              modifiedStatus[inputField] = VERIFIED;
                              docStatus[inputField] = VERIFIED;
                            } else {
                              modifiedStatus[inputField] = ACTION_REQUIRED;
                              docStatus[inputField] = ACTION_REQUIRED;
                              remarks = message;
                            }

                            setTimeout(
                              () =>
                                setStatus({
                                  ...status,
                                  [inputField]: remarks,
                                  fieldValidationResponse: {
                                    ...modifiedStatus,
                                  },
                                }),
                              0,
                            );
                          },
                        });
                      }
                      break;
                    case CIN:
                      if (
                        e.target.value &&
                        e.target.value.length === 21 &&
                        new RegExp(
                          /^([LUu]{1})([0-9]{5})([A-Za-z]{2})([0-9]{4})([A-Za-z]{3})([0-9]{6})$/,
                        ).test(e.target.value)
                      ) {
                        verifyCin({
                          payload: {
                            cin: e.target.value,
                            parentType: 'MERCHANT',
                            userName,
                            name: vendorOnboardingDetails?.name || name,
                          },
                          loadingFn,
                          errorCb,
                          cb: response => {
                            setLoading('');
                            const { isValid, message } = response;
                            const { fieldValidationResponse } = status;
                            const modifiedStatus = {
                              ...fieldValidationResponse,
                            };

                            let remarks = '';
                            if (isValid) {
                              modifiedStatus[inputField] = VERIFIED;
                              docStatus[inputField] = VERIFIED;
                            } else {
                              modifiedStatus[inputField] = ACTION_REQUIRED;
                              docStatus[inputField] = ACTION_REQUIRED;
                              remarks = message;
                            }
                            setTimeout(
                              () =>
                                setStatus({
                                  ...status,
                                  [inputField]: remarks,
                                  fieldValidationResponse: {
                                    ...modifiedStatus,
                                  },
                                }),
                              0,
                            );
                          },
                        });
                      }
                      break;
                    default:
                      break;
                  }
                  handleFieldBlur(e, data);
                };

                const handleInputChange = (e, data, inputField) => {
                  if (docStatus[inputField]) {
                    delete docStatus[inputField];
                  }
                  const { fieldValidationResponse } = status;
                  const modifiedStatus = { ...status };
                  delete modifiedStatus[inputField];
                  const modifiedValidationStatus = {
                    ...fieldValidationResponse,
                  };
                  modifiedValidationStatus[inputField] = '';
                  setStatus({
                    ...modifiedStatus,
                    fieldValidationResponse: { ...modifiedValidationStatus },
                  });

                  if (inputField === 'GSTIN') setGstinRemarks('');
                  // validate the input field
                  validateInputField(e, data, inputField);
                  // set loader to the input for the api call done above
                  handleFieldChange(e, data);
                };

                const renderDocLabel = doc => (
                  <Space
                    justifyContent="space-between"
                    alignItems="center"
                    className="mb-1"
                  >
                    <Space gap={1} alignItems="center">
                      <Text>{`Upload ${doc}`}</Text>
                      <Conditional if={optionalDocs.doc.includes(doc)}>
                        <div className="optional-field-label">Optional</div>
                      </Conditional>
                    </Space>
                    <Conditional if={isEditMode && !!docStatus[doc]}>
                      <StyledStatusText
                        status={docStatus[doc]}
                        color={
                          STATUS_COLOR_MAPPING[docStatus[doc]] || 'bodyLight'
                        }
                      >
                        {STATUS_TEXT_DISPLAY_MAPPING[docStatus[doc]] ||
                          titleCase(docStatus[doc])}
                      </StyledStatusText>
                    </Conditional>
                  </Space>
                );
                const renderInputField = inputField => (
                  <div className="mb-3">
                    <InputField
                      fluid
                      loading={loading === inputField}
                      disabled={!!loading}
                      id={inputField}
                      name={inputField}
                      label={renderInputLabel(inputField)}
                      value={values[inputField]}
                      errors={
                        status[inputField]
                          ? { [inputField]: status[inputField] }
                          : errors
                      }
                      touched={
                        status[inputField] ? { [inputField]: true } : touched
                      }
                      onBlur={handleFieldBlur}
                      onChange={(e, data) =>
                        handleInputChange(e, data, inputField)
                      }
                      placeholder={INPUT_PLACEHOLDER_MAPPING[inputField] || ''}
                    />
                    <Conditional
                      if={
                        inputField === 'GSTIN' &&
                        !!gstinRemarks &&
                        !errors[inputField]
                      }
                    >
                      <Text color="info" className="mt-1" variant="b12">
                        {gstinRemarks}
                      </Text>
                    </Conditional>
                  </div>
                );
                const renderUploadedDoc = doc => {
                  if (
                    values[doc]?.name ||
                    (typeof values[doc] === 'string' && values[doc].length)
                  ) {
                    return typeof values[doc] === 'string'
                      ? { name: values[doc] }
                      : { name: values[doc]?.name };
                  }
                  return null;
                };
                const renderDoc = doc => (
                  <div className="mb-3">
                    <UploadFile
                      type="secondary"
                      name={doc}
                      label={renderDocLabel(doc)}
                      checkList={[
                        '- Max file size: 25 MB',
                        '- File format: .png, .jpeg, .pdf, .jpg',
                      ]}
                      accept=".png, .jpeg, .pdf, .jpg"
                      disabled={!!loading}
                      errors={errors}
                      touched={touched}
                      onBlur={handleFieldBlur}
                      dataEventName="UploadFile_Vendor_KYC_Form"
                      dataEventProperties={JSON.stringify({
                        value: doc,
                      })}
                      onChange={response => handleFileChange(response, doc)}
                      uploaded={renderUploadedDoc(doc)}
                      editable={!isEditMode || docStatus[doc] !== IN_KYC_REVIEW}
                      customError={status[doc] ? status[doc] : null}
                      showPreview={() => showPreview(doc)}
                    />
                  </div>
                );

                return (
                  <form autoComplete="off" onSubmit={handleSubmit}>
                    <div
                      className="navigate-back"
                      data-event-name="Form_VendorKYC_Step3_Back"
                      data-ignore-inner-text="true"
                      onClick={() => setStep(step - 1)}
                    >
                      <CustomIcon componentName="CHEVRONDOWN" direction="up" />
                      <span>Back</span>
                    </div>
                    <Space justifyContent="space-between">
                      <Text variant="h16" strong className="mb-2">
                        Submit KYC Documents
                      </Text>
                      <span className="step">
                        Step {step}/{vendorDocs?.documents?.length ? 3 : 2}
                      </span>
                    </Space>
                    <Text variant="b14" color="bodyLight" className="mb-4">
                      Submit them now or come back later to finish KYC.
                      Documents needs to be verified to activate vendor.
                    </Text>
                    {documentList.map((docs, index) => {
                      // render for multiple documents
                      const sortedDocs = sortVendorKycDocuments(docs);

                      return (
                        // eslint-disable-next-line react/no-array-index-key
                        <div key={index}>
                          <>
                            {sortedDocs.map((doc, innerIndex) => {
                              const { inputType, docName } = doc;

                              const isInput = inputType === VALUE;
                              if (isInput) {
                                docInputTypeMapping[docName] = 'input';
                              } else {
                                docInputTypeMapping[docName] = 'doc';
                              }

                              return (
                                // eslint-disable-next-line react/no-array-index-key
                                <div key={innerIndex}>
                                  <>
                                    {isInput
                                      ? renderInputField(docName)
                                      : renderDoc(docName)}
                                  </>
                                  <Conditional
                                    if={innerIndex !== sortedDocs.length - 1}
                                  >
                                    <StyledTextDivider className="mt-1 mb-2">
                                      OR
                                    </StyledTextDivider>
                                  </Conditional>
                                </div>
                              );
                            })}
                            <Conditional if={index !== documentList.length - 1}>
                              <StyledDocCategoryDivider className="mb-2" />
                            </Conditional>
                          </>
                        </div>
                      );
                    })}
                    <div className="cta-wrapper btn-class">
                      <Popup
                        content={SAVE_AND_EXIT_BTN_INFO_TEXT}
                        trigger={
                          <Button
                            secondary
                            type="button"
                            data-event-name="Secondary_Button_Save_&_Exit"
                            data-event-properties={JSON.stringify({
                              innerText: 'Save & Exit',
                            })}
                            onClick={handleSaveAndExitClick}
                          >
                            Save & Exit
                          </Button>
                        }
                        position="top center"
                      />
                      <Button
                        type="submit"
                        primary
                        loading={disableField}
                        disabled={!docForEveryCateogorySubmitted}
                        data-event-name="Primary_Button_Submit_For_Approval"
                        data-event-properties={JSON.stringify({
                          innerText: 'Submit for Approval',
                        })}
                      >
                        Submit for Approval
                      </Button>
                    </div>
                  </form>
                );
              }}
            </FormikComponent>
          )}
        </div>
      </ModalContent>
    </Modal>
  );
}

KycFormV2.propTypes = {
  open: PropTypes.bool.isRequired,
  isEditMode: PropTypes.bool.isRequired,
  editModalLoading: PropTypes.bool,
  step: PropTypes.number.isRequired,
  setStep: PropTypes.func.isRequired,
  vendorDocs: PropTypes.object,
  submitVendorDocuments: PropTypes.func,
  verifyPan: PropTypes.func,
  verifyCin: PropTypes.func,
  verifyGst: PropTypes.func,
  saveAndExitKycForm: PropTypes.func,
  userInfo: PropTypes.object,
  setVendorCreated: PropTypes.func,
  downloadDoc: PropTypes.func,
  merchantVendorId: PropTypes.string,
  vendorOnboardingDetails: PropTypes.object,
  vendorFormData: PropTypes.object,
  setVendorFormData: PropTypes.func,
};

export default memo(KycFormV2);
